export const CONSTANTS = {
  HOURS_LIST: [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
  ],
  MIDDAY_HOURS_LIST: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
};
